/*
    TODO temporarily:

    - $rootScope.member
    - $rootScope.affiliate_id

    have been reassigned to context constant so we need to figure out a way to refactor that
 */
const context = {
    apiVersion: 'v1',
    apiUrl: null,
    isAdmin: false,
    appId: 'f6b16c23',
    appKey: 'f0bc4f65f4fbfe7b4b3b7264b655f5eb',
    authorization: null,
    withCredentials: true,
    pusher: {
        enabled: false,
        appKey: 'c8d8cea659cc46060608'
    },
    storage: 'local',
    enableMultiLanguageSupport: false
};

export {
    context
};
